import {
  css
} from 'lit';

export default css`
* {
  box-sizing: border-box;
}

.lds-tooltip {
  position: relative;
  display: inline-block;
}

.lds-tooltip:focus {
  border: 1px solid;
}

.lds-tooltip-description {
  cursor: pointer;
}

.lds-tooltip:not(.persistent):active .lds-tooltip-description {
  transform: scale(1.02);
  box-shadow: 3px 6px 12px rgba(33, 33, 33, .1);
}

.tooltip-description {
  display: none;
  position: absolute;
  left: 50%;
  z-index: var(--lds-spacing-tooltip-panel-z-index);
  padding-top: var(--lds-spacing-tooltip-panel-padding-top);
  padding-right: var(--lds-spacing-tooltip-panel-padding-right);
  padding-bottom: var(--lds-spacing-tooltip-panel-padding-bottom);
  padding-left: var(--lds-spacing-tooltip-panel-padding-left);
  font: var(--lds-typography-font-sm);
  text-align: var(--lds-typography-tooltip-panel-text-align);
  background: var(--lds-color-tooltip-panel-background);
  border-color: var(--lds-color-tooltip-panel-border);
  border-style: var(--lds-border-tooltip-panel-style);
  border-width: var(--lds-border-tooltip-panel-width);
  border-radius: var(--lds-radius-tooltip-panel);
  outline: none;
  box-shadow: 0 3px 8px rgba(33, 33, 33, .2);
  transition: box-shadow 100ms, transform 100ms;
  cursor: pointer;
}

.lds-tooltip-arrow {
  position: absolute;
}

.lds-tooltip-arrow::before {
  position: absolute;
  width: 0;
  height: 0;
  margin-left: -10px;
  border-style: solid;
  content: '';
}
.lds-tooltip-arrow::after {
  position: absolute;
  width: 0;
  height: 0;
  margin-left: -8px;
  border-style: solid;
  content: '';
}

/* Bottom position offset when the tooltip is "top" (above) the label */
.tooltip-description.top {
  bottom: calc(100% + var(--lds-spacing-tooltip-above-position-bottom));
}
.tooltip-description.top .lds-tooltip-arrow {
  top: 100%;
}

/* WARNING :root variables are not availale in the ::before context */
.tooltip-description.top .lds-tooltip-arrow::before {
  border-color: #212121 transparent transparent;
  border-width: 12px 10px 0;
}

/* WARNING :root variables are not availale in the ::after context */
.tooltip-description.top .lds-tooltip-arrow::after {
  border-color: #F5F5F5 transparent transparent;
  border-width: 10px 8px 0;
}

/* Top position offset when the tooltip is "bottom" (below) the label */
.tooltip-description.bottom {
  top: calc(100% + var(--lds-spacing-tooltip-below-position-top));
}

.tooltip-description.bottom .lds-tooltip-arrow {
  bottom: 100%;
}

/* WARNING :root variables are not availale in the ::before context */
.tooltip-description.bottom .lds-tooltip-arrow::before {
  bottom: 100%;
  border-color: transparent transparent #212121;
  border-width: 0 10px 12px;
}

/* WARNING :root variables are not availale in the ::after context */
.tooltip-description.bottom .lds-tooltip-arrow::after {
  bottom: 100%;
  border-color: transparent transparent #F5F5F5;
  border-width: 0 8px 10px;
}

.tooltip-description.persistent {
  cursor: initial;
}

.open .tooltip-description {
  display: inline;
}

.tooltip-container {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
}

.tooltip-text {
  position: relative;
  font-weight: var(--lds-typography-tooltip-label-font-weight) !important;
  text-decoration: var(--lds-typography-tooltip-label-text-decoration);
}

.tooltip-text:focus {
  outline-color: var(--lds-color-tooltip-label-focus-outline);
  outline-offset: var(--lds-border-tooltip-label-focus-outline-offset);
  outline-style: var(--lds-border-tooltip-label-focus-outline-style);
  outline-width: var(--lds-border-tooltip-label-focus-outline-width);
}

.tooltip-icon {
  margin-right: .125em;
  margin-left: .25em;
  vertical-align: text-bottom;
}

.tooltip-close {
  position: absolute;
  top: .4rem;
  right: .4rem;
}

.lds-tooltip-enter,
.lds-tooltip-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 200ms, transform 200ms;
}

.lds-tooltip-enter-to,
.lds-tooltip-leave {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 200ms, transform 200ms;
}
`;
